module.exports = __webpack_public_path__ + "img/naoConsta.378303e9.svg";